export const expectAtIndex = <TArray extends ReadonlyArray<unknown>>(
  array: TArray,
  index: number,
): TArray[number] | never => {
  const element = array[index];

  if (element === undefined) {
    throw new TypeError(
      `${index} is not a valid index for the given array of length ${array.length}`,
    );
  } else {
    return element;
  }
};
